import { TreeType } from './tree-type'
class Search {
  onSelectClear () {
    console.error('onSelectClear function must be rwrite')
  }
  onSearchChange () {
    console.error('onSearchChange function must be rwrite')
  }
  onQueryChange () {
    console.error('onQueryChange function must be rwrite')
  }
  searchTreeList () {
    console.error('searchTreeList function must be rwrite')
  }
}

export class AsyncSearch extends Search {
  searchTreeList () {
    this.treeResultList = []
    this.searchQueryPage()
    this.searchResultMap.set(this.currentQuery, this.treeResultList)
  }
  onSelectClear () {
    this.treeResultList = []
  }
  onSearchChange (id) {
    let item = this.treeResultList.find(item => item.id === id),
      dataPath = item && item.dataPath && item.dataPath.replace(/^\/|\/$/g, '').split('/'),
      level = this.getRootPath(dataPath) - 1,
      lastNode = null
    if (!dataPath) return
    this.transferData(this.treeData, (item) => {
      if (dataPath.includes(item.id)) {
        level++
        lastNode = item
      }
    })
    // 直接选中即可
    if (level === dataPath.length - 1) {
      this.currentSelect = lastNode
      this.changeSelectStatus(lastNode)
      this.onSelectChange([lastNode], 'search')
      return
    }
    this.$ajax({
      url: this.requestGroup.lazy,
      data: (this.treeCustomData && Object.keys(this.treeCustomData).length != 0) ? this.treeCustomData.getLazyParams(dataPath[level], item.id, Object.assign({}, this.treeParams)) : TreeType.getLazyParams({
        startId: dataPath[level],
        id: item.id,
        ...this.treeParams
      }),
      method: this.requestGroup.lazy == 'api-uum/uum/org/tree/single/getDetail' ? 'get' : 'POST'
    }).then(({ data }) => {
      this.transferData(data.data, (child) => {
        if (child.selected) {
          this.currentSelect = child
        }
      })
      if (!this.ztreeObj.getNodeByParam('id', data.data[0].id)) {
        this.ztreeObj.addNodes(this.ztreeObj.getNodeByParam('id', dataPath[level]), data.data)
      }
      this.changeSelectStatus()
      this.onSelectChange([this.currentSelect], 'search')
    })
  }
  onQueryChange (query) {
    this.currentQuery = query
    this.$refs.Select.visible = false
  }
  getRootPath (path = []) {
    return path.findIndex(p => this.rootIds.indexOf(p) >= 0)
  }
}

export class SyncSearch extends Search {
  onSelectClear () {
    this.treeResultList = []
  }
  onSearchChange (id) {
    if (!id) return
    const item = this.treeResultList.find(item => item.id === id)
    let parent = item?._parent
    while (parent) {
      this.ztreeObj.expandNode(parent, true, false, true)
      parent = parent._parent
    }
    this.$set(item, 'selected', true)
    this.$set(this.currentSelect, 'selected', false)
    this.currentSelect = item
    this.changeSelectStatus()
    if (item) {
      this.onSelectChange([item], 'search')
    }
  }
  onQueryChange (query) {
    this.currentQuery = query
    this.$refs.Select.visible = false
  }
  searchTreeList () {
    this.$refs.Select.visible = true
    if (this.searchResultMap[this.currentQuery]) return (this.treeResultList = this.searchResultMap[this.currentQuery])
    this.treeResultList = []
    this.searchCode(this.treeData, this.currentQuery)
    this.searchResultMap[this.currentQuery] = this.treeResultList
  }
  searchCode (arr, code, parent) {
    arr.forEach((item, key) => {
      item._parent = parent
      item.children && item.children.length && this.searchCode(item.children, code, item)
      if (item.title.indexOf(code) > -1) {
        // 下拉
        this.curID = item.nodeKey
        this.treeResultList.push(item)
      }
    })
  }
}
